/**
 * @packageDocumentation
 * @module StockChartModule
 */
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { isEmptyObject } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';

@Component({
  selector: 'app-sma-model',
  templateUrl: './sma-model.component.html',
  styleUrls: ['./sma-model.component.scss']
})
export class SmaModelComponent implements OnInit {
  @Input() formValue: any;
  smaFormGroup = new FormGroup({
      numberOfDays: new FormControl(1, Validators.required),
      showSMA: new FormControl(false, Validators.required)
  });

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if (!isEmptyObject(this.formValue)) {
      this.smaFormGroup.setValue(this.formValue);
    }
  }

  closeModal() {
    this.activeModal.close(this.smaFormGroup.value);
  }

}
